// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 763 ? "7795b455" : chunkId) + "-" + {"13":"433d26782485d6c9","226":"b59072ed0c2e87ab","763":"53667e0e30258655"}[chunkId] + ".js";
};